import { isEmpty } from '@automation/core/utils';

export async function fetchApiSimple(url, config) {
  let flowError;
  try {
    const { result, status } = await doFetch();
    if (status === 200 || status === 201) {
      return result;
    }
    flowError = { result, status };
  } catch (err) {
    console.debug(`Error when fetching api: ${url}`, err);
    flowError = {
      code: 'UNKNOWN_ERROR',
      message: 'خطای نامشخص لطفا دوباره سعی کنید',
    };
  }
  if (flowError) {
    throw flowError;
  }
  return null;

  async function doFetch() {
    const response = await fetch(url, config);
    const result = await response.json();
    return { result: result?.data ?? result, status: response.status };
  }
}

export function getPostConfigSimple(body, additionalHeader) {
  return {
    method: 'POST',
    headers: getHeadersSimple(additionalHeader),
    ...(isEmpty(body) ? {} : { body: JSON.stringify(body) }),
  };
}

export function getPostMultiPartConfigSimple(body, additionalHeader) {
  return {
    method: 'POST',
    headers: getHeadersSimple(additionalHeader),
    body,
  };
}

export function getPutConfigSimple(body, additionalHeader) {
  return {
    method: 'PUT',
    headers: getHeadersSimple(additionalHeader),
    ...(isEmpty(body) ? {} : { body: JSON.stringify(body) }),
  };
}

export function getPutMultiPartConfigSimple(body, additionalHeader) {
  return {
    method: 'PUT',
    headers: getHeadersSimple(additionalHeader),
    body,
  };
}

export function getGetConfigSimple(additionalHeader) {
  return {
    method: 'GET',
    headers: getHeadersSimple(additionalHeader),
  };
}

export function getDeleteConfigSimple(body, additionalHeader) {
  return {
    method: 'DELETE',
    headers: getHeadersSimple(additionalHeader),
    ...(isEmpty(body) ? {} : { body: JSON.stringify(body) }),
  };
}

function getHeadersSimple(additionalHeaders = {}) {
  return additionalHeaders;
}

export function getCandoRequestHeaders() {
  return { companyApiKey: process.env.CANDO_API_KEY, 'content-type': 'application/json' };
}
